import React from "react";

import PhotosUploadField from "./PhotosUploadField";
import styles from "./PhotosUploadScreen.mscss";

export default function PhotosUploadScreen(props) {
    return (
        <div className={styles.PhotosUploadScreen}>
            <PhotosUploadField {...props} />
        </div>
    );
}
